// extracted by mini-css-extract-plugin
export var deleteModal = "_sm-0";